import React from 'react';

const footer = () => {
    return(
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <a href="https://github.com/Etaloot" target="_blank" rel="noreferrer">
                            <span className="copy">&copy; Copyright 2023 - Etaloot Dev</span>
                        </a>
                    </div>
                    <div className="col-md-6">
                        <div className="social-icons">
                            <a href="https://www.facebook.com/FreshLeo333" target="_blank" rel="noreferrer"><i className="fa fa-facebook"></i></a>
                            <a href="https://www.instagram.com/leo_fresh_tattoo?igsh=aXR2cTBkN2NiaTd0&utm_source=qr" target="_blank" rel="noreferrer"><i className="fa fa-instagram fa-lg"></i></a>
                            {/* <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer"><i className="fa fa-linkedin"></i></a> */}
                            {/* <a href="https://pinterest.com/" target="_blank" rel="noreferrer"><i className="fa fa-pinterest"></i></a>
                            <a href="https://www.envato.com" target="_blank" rel="noreferrer"><i className="fa fa-rss"></i></a> */}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default footer;